export default "__VITE_ASSET__DSEg6a8c__"